module.exports = __webpack_public_path__ + "static/media/procedure_instructions_big.b712e225.png";